import type { jiraBusinessParentFieldFragment } from '../field-types/parent/fragment/types';
import type {
	jiraMultipleVersionPickerField,
	jiraSingleVersionPickerField,
} from '../field-types/version/fragment/types';

export const isJiraBusinessFields = (_: unknown): _ is jiraBusinessFields => true;

export type jiraBusinessFields =
	| jiraBusinessParentFieldFragment
	| jiraMultipleVersionPickerField
	| jiraSingleVersionPickerField;
